<template>
  <div class="home">
    <div class="home-hero" :class="{'reverse': cvData.hero.announcement && cvData.hero.announcement.reverse}">
      <div class="flex container container-hero">
        <div class="content-hero">
            <h1 v-html="(pageName=='let' ? cvData.hero.let.title : cvData.hero.title)"></h1>
            <p v-html="cvData.hero.description"></p>
        </div>
        <div class="animated-hero">
          <div class="flip-container">
            <div class="flipper">
              <div class="front">
                <img src="pp-square-large.png" alt="Profile picture" class="main">
              </div>
              <div class="back">
                <img src="pp-square-large-pix.png" alt="Profile picture NFT" class="main">
              </div>
            </div>
          </div>
          <div class="satellites">
            <div :class="'satellite satellite-'+keywordID" :hover-tooltip="keyword.alt" tooltip-position="bottom" v-for="(keyword, keywordID) in cvData.hero.keywords" :key="keywordID">
              <img :src="'emojis/'+keyword.emoji+'.png'" :alt="keyword.alt">
            </div>
          </div>
        </div>
      </div>
      <div v-if="cvData.hero.announcement && cvData.hero.announcement.visible" class="announcement">
        <div class="flex container">
          <div class="flex container">
            <div><small class="uppercase bold" v-html="cvData.hero.announcement.date"></small>{{ cvData.hero.announcement.title }}</div>
            <router-link :to="cvData.hero.announcement.link">
                <span>{{ cvData.hero.announcement.link.label }}</span>
              </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="categories">
      <section class="category category-feature-posts" v-if="cvData.featuredPosts && pageName!='let'">
        <div class="container large">
          <div class="col-13">
            <h2 class="title" id="featured-posts">{{cvData.featuredPosts.title}}</h2>
            <p>{{cvData.featuredPosts.description}}</p>
          </div>
          <div class="col-23 articles">
            <article v-for="(post, postID) in cvData.featuredPosts.list" :key="postID">
              <div class="post-images" :class="'post-images-'+post.assets.length">
                <img alt="" :src="postimg.url" v-for="(postimg, postImgId) in post.assets" :key="postImgId"/>
              </div>
              <div class="post-content">
                <h2 v-html="post.title"></h2>
                <p v-html="post.description"></p>
                <a :href="link.url" target="_blank" class="read-more" v-for="(link, linkID) in post.links" :key="'link-post-'+linkID">
                  <span>{{ link.label }}</span>
                </a>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section class="category category-experience">
        <div class="container large">
          <div class="col-13">
            <h2 class="title" id="work-experience">{{cvData.experience.title}}</h2>
            <p>{{cvData.experience.description}}</p>
          </div>
          <div class="col-23">
            <div v-for="(company, companyID) in cvDataExp" :key="companyID" class="company">
              <div class="company-logo">
                <img :alt="company.name" width="200" height="200" loading="lazy" :src="require('@/assets/img/company/'+company.id+'-pix.jpg')" aria-hidden="true"/>
                <div class="group-logo" v-if="company.group">
                  <img :alt="company.group" width="50" height="50" loading="lazy" :src="require('@/assets/img/company/'+company.group+'-pix.jpg')" aria-hidden="true"/>
                </div>
              </div>
              <div class="company-jobs">
                <div v-for="(item, itemID) in jobs(company.jobs)" :key="itemID" class="job" :class="{'current': item.current, 'future': item.future}">
                  <h3 class="title">{{item.name}} <span class="sec">at <a :href="company.url" target="_blank">{{company.name}}</a></span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" v-if="company.info" :data-title="company.info" class="i-icon">
                    <path id="information-circle" d="M18,10a8,8,0,1,1-8-8A8,8,0,0,1,18,10ZM11,6a1,1,0,1,1-1-1A1,1,0,0,1,11,6ZM9,9a1,1,0,0,0,0,2v3a1,1,0,0,0,1,1h1a1,1,0,0,0,0-2V10a1,1,0,0,0-1-1Z" transform="translate(-2 -2)" fill="#4a5568" fill-rule="evenodd"/>
                  </svg>
                </h3>
                  <span class="time"><span class="sr-only" v-if="!item.current && !item.future">from </span><span class="sr-only" v-if="item.current">since </span><span class="sr-only" v-if="item.future">starting </span>{{item.from}} <span class="sr-only" v-if="item.to">to</span><span aria-hidden="true" v-if="item.to">-</span> {{item.to}} <span v-if="item.fromDate && item.toDate && duration(item.fromDate,item.toDate)">({{duration(item.fromDate,item.toDate)}})</span></span>
                  <span class="place">{{item.place}}</span>
                  <p v-if="item.description  && item.displayDesc" v-html="item.description"></p>
                  <div class="keyEvents--container" v-if="keypoints(item.keyEvents).length > 0">
                    <div class="keyEvents">
                      <span class="sr-only">Key points</span>
                      <div class="keyEvent" :class="keyEvent.icon" v-for="(keyEvent, keyEventID) in keypoints(item.keyEvents)" :key="keyEventID">
                        <strong v-html="keyEvent.name"></strong>
                        <div v-html="keyEvent.date" v-if="keyEvent.date"></div>
                        <div v-if="keyEvent.organisation">
                          <a target="_blank" rel="noopener" class="tarbl" :href="keyEvent.organisation.url" v-if="keyEvent.organisation.url" v-html="keyEvent.organisation.name"></a>
                          <span v-html="keyEvent.organisation.name" v-else></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="products--container" v-if="item.products && item.displayProducts">
                    <div class="products">
                      <div class="product" v-for="(product, productID) in products(item.products)" :key="productID">
                        <img :alt="product.title" loading="lazy" :src="'product/'+product.id+'.jpg'" />
                        <div>
                          <h4>{{ product.title }}</h4>
                          <p>{{ product.description }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clients--container" v-if="item.clients && item.displayClients">
                    <span class="title">
                      <small v-if="item.clients.length > 1">Main clients</small>
                      <small v-else>Main client</small>
                    </span>
                    <div class="clients">
                      <div class="client" v-for="(client, clientID) in item.clients" :key="clientID">
                        <figure>
                          <a :href="client.url" v-if="client.url"><img :alt="client.name" loading="lazy" :src="require('@/assets/img/brands/'+client.id+'.jpg')" /></a>
                          <img v-else :alt="client.name" loading="lazy" :src="require('@/assets/img/brands/'+client.id+'.jpg')" />
                          <figcaption v-if="client.legend" v-html="client.legend"></figcaption>
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="category category-training">
        <div class="container large">
          <div class="col-13">
            <h2 class="title" id="training">{{cvData.training.title}}</h2>
            <p v-if="cvData.training.description">{{cvData.training.description}}</p>
          </div>
          <div class="col-23">
            <div v-for="(company, companyID) in cvDataTraining" :key="companyID" class="company">
              <div class="company-logo">
                <img :alt="company.name" loading="lazy" :src="require('@/assets/img/company/'+company.id+'-pix.jpg')" aria-hidden="true"/>
              </div>
              <div class="company-jobs">
                <div v-for="(item, itemID) in company.jobs" :key="itemID" class="job" :class="{'current': item.current, 'future': item.future}">
                  <span class="title">{{item.name}} <span class="sec">with <a :href="company.url" v-if="company.url">{{company.name}}</a><span v-else>{{company.name}}</span></span></span>
                  <span class="time" v-if="item.from && item.to"><span class="sr-only">from </span>{{item.from}} <span class="sr-only">to</span><span aria-hidden="true">-</span> {{item.to}} <span v-if="item.fromDate && item.toDate">({{duration(item.fromDate,item.toDate)}})</span></span>
                  <span class="time" v-else><span class="sr-only">in </span>{{item.in}}<span v-if="item.inprogress"> (Ongoing)</span></span>
                  <span class="place">{{item.place}}</span>
                  <p class="description" v-if="item.description && (item.displayDesc || item.displayDesc)">
                    <span v-html="item.description"></span>
                    <span class="links" v-if="item.links">
                      <a :href="link.url" v-for="(link, linkID) in item.links" target="_blank" :key="item.name+'-'+linkID">
                        <span>{{ link.label }}</span>
                      </a>
                    </span>
                  </p>
                  <span v-if="item.pils" class="pils">
                    <span class="pil" v-for="(pil, pilID) in item.pils" :key="itemID+'-'+pilID" v-html="pil"></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container large" id="fastTracks" v-if="pageName!='let'">
          <div class="col-13"></div>
          <div class="col-23">
            
              <div class="fastTracks">
              <h3>{{cvData.fastTracks.title}} <span class="count">{{ countItems(this.cvData.fastTracks.list) }}</span></h3>
              <p v-if="cvData.fastTracks.description">{{cvData.fastTracks.description}}</p>
              <Transition name="slide-fade">
                <div class="fastTrackItems">
                  <div v-for="(fastTrack, fastTrackId) in cvDataFastTracks" :key="fastTrackId" class="fastTrackItem">
                    <div class="asset" v-if="fastTrack.asset">
                      <a :href="fastTrack.nft" v-if="fastTrack.nft">
                        <img v-if="fastTrack.asset.type == 'image'" :src="fastTrack.asset.url" alt="" />
                      </a>
                      <img v-else :src="fastTrack.asset.url" alt="" />
                    </div>
                    <div class="content">
                      <span class="title">{{fastTrack.name}}</span>
                      <span class="time"><span class="sr-only">in </span>{{fastTrack.in}}</span>
                      <p class="description" v-if="fastTrack.description && (fastTrack.displayDesc || fastTrack.displayDesc)" v-html="fastTrack.description"></p>
                      <span v-if="fastTrack.pils" class="pils">
                        <span class="pil" v-for="(pil, pilID) in fastTrack.pils" :key="itemID+'-'+pilID" v-html="pil"></span>
                      </span>
                      <div class="links" v-if="fastTrack.links">
                        <a :href="link.url" v-for="(link, linkID) in fastTrack.links" target="_blank" :key="fastTrack.nameD+'-'+linkID">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6" v-if="link.type=='nft'">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25" />
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6" v-if="link.type=='document'">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                          </svg>

                          <span>{{ link.label }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </Transition>
              <button class="more" v-on:click="fastTrackOpen = !fastTrackOpen" v-if="!fastTrackOpen">See more LVMH Fast Tracks</button>
              <button class="less" v-on:click="fastTrackOpen = !fastTrackOpen" v-if="fastTrackOpen">See less LVMH Fast Tracks</button>
            </div>
          </div>
        </div>
      </section>
      <section class="category category-education">
        <div class="container large">
          <div class="col-13">
            <h2 class="title" id="education">{{cvData.education.title}}</h2>
            <p>{{cvData.education.description}}</p>
          </div>
          <div class="col-23">
            <div v-for="(company, companyID) in cvDataEdu" :key="companyID" class="company">
              <div class="company-logo">
                <img :alt="company.name" loading="lazy" :src="require('@/assets/img/company/'+company.id+'-pix.jpg')" aria-hidden="true"/>
              </div>
              <div class="company-jobs">
                <div v-for="(item, itemID) in company.jobs" :key="itemID" class="job" :class="{'current': item.current, 'future': item.future}">
                  <span class="title">{{item.name}} <span class="sec">at {{company.name}}</span></span>
                  <span class="time" v-if="item.from && item.to"><span class="sr-only">from </span>{{item.from}} <span class="sr-only">to</span><span aria-hidden="true">-</span> {{item.to}} <span v-if="item.fromDate && item.toDate">({{duration(item.fromDate,item.toDate)}})</span></span>
                  <span class="time" v-else><span class="sr-only">in </span>{{item.in}}</span>
                  <span class="place">{{item.place}}</span>
                  <p class="description" v-if="item.description && (item.displayDesc || item.displayDesc)" v-html="item.description"></p>
                  <span v-if="item.pils" class="pils">
                    <span class="pil" v-for="(pil, pilID) in item.pils" :key="itemID+'-'+pilID" v-html="pil"></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="category category-instagram">
        <div class="container large insta-imgs">
          <div class="insta-title">
            <div class="insta-img-container">
              <div class="detail-img">
                <div class="post">
                    <h2 class="title" id="memories">{{instagrams.title}}</h2>
                    <p v-if="instagrams.description">{{instagrams.description}}</p>
                    <p>
                      <a :href="'https://www.instagram.com/'+instagrams.account.nickname">
                        <div class="icon">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="33" viewBox="0 0 26 26" width="32">
                            <g stroke="currentColor" stroke-miterlimit="10" stroke-width="2">
                              <path d="m2 16.5h28"/>
                              <path d="m21 7.5 9 9-9 9" stroke-linecap="square"/>
                            </g>
                          </svg>
                        </div>
                        <span>Follow me on instagram</span>
                      </a>
                    </p>
                </div>
              </div>
            </div>
          </div>
          <div class="insta-img" v-for="(instagram, instaID) in instagramsPosts" :key="instaID" ref="instaImgs">
            <div class="insta-img-container">
              <a target="_blank" rel="noopener" :href="instagram.url" v-if="instagram.url">
                <img :src="require('@/assets/img'+instagram.imgurl)" width="1080" height="1080" loading="lazy"  :alt="instagram.description" />
              </a>
              <img :src="require('@/assets/img'+instagram.imgurl)" width="1080" height="1080" loading="lazy"  :alt="instagram.description" v-else />
              <div class="detail-img">
                <div class="post">
                  <span v-if="instagram.description">
                    {{instagram.description}}
                  </span>
                  <div aria-hidden="true" class="place" v-if="instagram.place">{{instagram.place}}</div>
                  <div aria-hidden="true" class="date" v-if="instagram.date">{{instagram.date}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import cv from '@/assets/data/cv.json'
import projects from '@/assets/data/projects.json'
import instagramData from '@/assets/data/instagram.json'
export default {
  name: 'home',
  data () {
    return {
      projectsData: projects.projects,
      instagramData: instagramData,
      cvData: cv,
      mode: 'short',
      specialMode: '',
      web3: 'luini.eth',
      dark: false,
      loaded: false,
      fastTrackOpen: false,
      pageName: this.$route.name
    }
  },
  mounted: function () {
    this.observeInstagramImages();
  },
  methods: {
    countItems(items){
      return items.length;
    },
    observeInstagramImages() {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.03
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        } else {
          entry.target.classList.remove('visible');
        }
      });
    }, observerOptions);

    this.$refs.instaImgs.forEach(el => {
      observer.observe(el);
    });
    
  },
    duration (dateStart, dateEnd) {
      if(dateStart){
        let firstDate = (dateEnd == 'today' ? moment(new Date()) : moment(dateEnd, "DD/MM/YYYY"));
        let yearDiff = firstDate.diff(moment(dateStart, "DD/MM/YYYY"), "year");
        let monthDiff = firstDate.diff(moment(dateStart, "DD/MM/YYYY"), "month") - (yearDiff*12);
        return ( yearDiff> 0 ? (yearDiff > 1 ? yearDiff + " years" : yearDiff + " year" ) : "" ) + (yearDiff> 0 && monthDiff> 0 ? " and " : "" ) + ( monthDiff> 0 ? (monthDiff > 1 ? monthDiff + " months" : monthDiff + " month" ) : "" );
      }
      return '';
    },
    keypoints (kp) {
      if (this.mode == 'full'){
        return _.filter(kp, { 'enabled': true })
      }
      return _.filter(kp, { 'enabled': true, 'default': 'visible' })
    },
    jobs (j) {
      if (this.mode == 'full'){
        return j
      }
      return _.filter(j, { 'visible': true })
    },
    products (j) {
      if (this.mode == 'full'){
        return j
      }
      return _.filter(j, { 'visible': true })
    }
  },
  computed: {
    instagrams () {
      return this.instagramData
    },
    instagramsPosts () {
      return _.filter(this.instagramData.posts, { 'active': true })
    },
    cvDataExp () {
      if (this.mode == 'full'){
        return _.filter(this.cvData.experience.list, { 'default': 'visible' })
      }
      return _.filter(this.cvData.experience.list, { 'default': 'visible' })
    },
    cvDataEdu () {
      if (this.mode == 'full'){
        return this.cvData.education.list
      }
      return _.filter(this.cvData.education.list, { 'default': 'visible' })
    },
    cvDataTraining () {
      return _.filter(this.cvData.training.list, { 'default': 'visible' })
    },
    cvDataFastTracks () {
      let fastTracks = _.filter(this.cvData.fastTracks.list, { 'visible': true });
      if(this.fastTrackOpen){
        return fastTracks
      }
      return [fastTracks[0],fastTracks[1]]
    },
    projects () {
      if (this.mode == 'full'){
        return _.sortBy(_.filter(this.projectsData, { 'enable': true }), 'home.order')
      }
      return _.filter(this.projectsData, { 'enable': true, 'default': true })
    },
    projectsTotal () {
      return _.filter(this.projectsData, { 'enable': true })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
@import '../assets/scss/_elements.scss';
  h1,h2,h3,h4,h5,h6{
    margin: 0;
  }
  h2{
    font-family: $fontDetail;
    font-size: 1.8em;
  }

  h3{
    &+p{
      color: #6E6E6E;}
  }
  .i-icon{
    position: relative; top: 2px; margin-left: 4px;
    &:after{
      content:attr(data-title);
    }
  }
  .home-hero{
    padding-top:80px;
    padding-bottom:80px;
    background: var(--bgHero);
    overflow:hidden;
    display: flex;
    flex-direction: column;
    &.reverse{
      flex-direction: column-reverse;
      .announcement .container .container{
        top:-40px;
      }
    }
    .announcement .container .container{
      background: white;
      border-radius: 16px;
      padding: 16px;
      justify-content: space-between;
      position: relative;
      top:40px;
      width:100%;
      gap:12px;
      text-wrap: balance;
      .uppercase.bold{
        font-weight: bold;
        text-transform: uppercase;
        color:var(--detail);
        margin-bottom:8px;
        font-size: 0.7em;
        display: block;
        font-family: $fontDetail;
      }

      a{
        display: flex;
        align-items: center;
        color: inherit;
        text-decoration: none;
        padding: 0 16px;
        padding-top: 2px;
        min-height: 40px;
        border-radius: 8px;
        transition: all 0.5s ease-in-out;
        color: var(--detail);
        border: 2px solid var(--detail);
        span{
          display: block;
          font-size: 0.8em;
          position: relative;
          font-family:  "Inter", sans-serif;
          margin-bottom: 0;
          font-style: normal;
          font-weight:bold;
        }
        &:hover{
          background: var(--detail);
          color:white;
        }
      }
    }
    .container-hero{
      align-items: center;
      flex-direction: column-reverse;
      gap:40px;
      @media screen and (min-width: 48em) {
        flex-direction: row;
        gap:0;
      }
    }
    .content-hero{
      width: 100%;
      @media screen and (min-width: 48em) {
        max-width: 67%;
      }
      h1{
        line-height: 1;
        font-family: $fontDetail;
      }
      p{
        line-height: 1.25em;
        text-wrap: balance;
        max-width: 90%;
      }

      a{
        display: inline-flex;
        align-items: center;
        color: inherit;
        text-decoration: none;
        padding: 8px 16px;
        padding-left: 8px;
        margin: 0 8px 8px;
        border-radius: 4px;
        transition: background 0.5s ease-in-out;
        background: var(--detail);
        color: #083a5d;
        .icon{
          height: 2rem;
          width: 2rem;
          margin-right: 1rem;
          opacity: 0.8;
          transition: transform 0.5s ease-in-out;
          svg{
            height: 2rem;
            width: 2rem;
            path{
              transform: scale(.8);
            }
          }
        }
        span{
          display: block;
          font-size: 1em;
          position: relative;
          &:after{
            content:"";
            height: 1px;
            background: currentColor;
            display: block;
            transition-delay: 0s;
            position: absolute;
            bottom: -2px;
            right: 0;
            left: 100%;
          }
        }
        &:hover{
          .icon{
            transform: translateX(8px);
          }
          background: transparent;
          color: var(--fntPromo1);
        }
      }
    }
    .animated-hero{
      max-width: 368px;
      margin: auto;
      @media screen and (min-width: 48em) {
        max-width: 33%;
      }
      width: 100%;
      position: relative;
      &:before{
        padding-top:100%;
        width:100%;
        content:"";
        display: block;
      }
      &:hover .flipper { 
          transform: rotateY(180deg);  	
        } 
      .flip-container{
        perspective:1000;
        position: absolute;
        top:25%;
        bottom:25%;
        left:25%;
        right: 25%;
        .flipper{
          transition: 1s;  	
          transform-style: preserve-3d;    	
          position: relative;
          .front, .back {  	
            backface-visibility: hidden;    	
            position: absolute;  	
            top: 0;  	
            left: 0;
            width: 100%;
            height: 100%;
          }
          .front {
            z-index: 2; 
          }     
          .back { 
            transform: rotateY(180deg);
          }
        }
      }
      .main{
        width: 100%;
        border-radius: 50%;
        background:white;
        border: solid 4px var(--detail);
        transform-origin: center;
      }
      .satellites {
        .satellite{
          position: absolute;
          animation-name: spin;
          animation-direction: reverse;
          animation-duration: 60s;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
          width: 24%;
          img{
            width: 100%;
            border-radius: 50%;
            background:white;
            border: solid 4px var(--detail);
            transition: all 400ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
            transform-origin: center;
          }
          &:hover{
            z-index: 100;
            img{
              transform: scale(1.3);
            }
          } 
        }
        width: 100%;
        height : 100%;
        position: absolute;
        top:0%;
        left:0%;
        animation-name: spin;
        animation-duration: 60s;
        transform-origin: center;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
          transform-origin: center;

        .satellite-0{
          right: 50%;
          top: 80%;
        }
        .satellite-1{
          right: 0%;
          top: 60%;
            width: 26%;
        }
        .satellite-2{
          right: 10%;
          top: 10%;
            width: 20%;
        }
        .satellite-3{
          left: -5%;
          top: 40%;
        }
        .satellite-4{
          left: 30%;
          top: 3%;
            width: 18%;
        }
      }
    }
  }
  .categories{
    overflow: hidden;
    padding-top: 80px;
    .category{
      padding-bottom: 80px;
      position: relative;
      &.category-feature-posts .articles{
        display: flex;
        flex-direction: column;
        gap: 16px;
        article{
          padding: 16px !important;
          border-radius: 16px;
          border: 2px solid var(--detail);
          display: flex;
          flex-direction: column;
          @media screen and (min-width: 48em) {
            flex-direction: row;
            }
          gap:16px;
            &:nth-child(even){
            @media screen and (min-width: 48em) {
              flex-direction: row-reverse;
            }
          }
          .post-content{
            text-wrap: pretty;
            margin:0;
            width: 100%;
            @media screen and (min-width: 48em) {
              width: 70%;
            }
            h2{
              font-family: "Funnel Display", serif;
              color: var(--detail);
              font-size: 1em;
            }
            p{
              line-height: 1.2em;
            }
            a{
          color: black;
          margin: 8px 0;
          text-decoration: none;
          position: relative;
          &:before{
            content:"";
            width: 100%;
            height: 1px;
            display: block;
            position: absolute;
            left: 0;
            background: var(--detail);
            bottom: 0;
            transition: all 0.5s ease;
          }
          &:hover{
            &:before{
              width: 0%;
              left: 100%;
            }
          }
        }
          }
          .post-images{
            display: flex;
            gap: 8px;
            flex-wrap: wrap;
            justify-content: space-between;
            width: 100%;
            @media screen and (min-width: 48em) {
              width: 50%;
            }
            &.post-images-4{
              img{
                width: calc(33.3333% - 6px);
              }
              img:first-child{
                width: 100%;
              }
            }
          img{
            width: 100%;
            height: auto;
            border-radius: 8px;
            object-fit: cover;
          }
          }
        }
      }
      &.category-instagram{
         color: var(--bgPromo2);
         background: var(--actionFNT);
         padding: 80px 0;
         margin-top: 80px;
      }
      .fastTracks{
        padding-top: 80px;
        h3{
          span.count{
            display: inline-flex;
            background: var(--detail);
            align-items: center;
            align-content: center;
            padding: 4px 8px 2px;
            border-radius: 50px;
            margin-left: 4px;
            color:white;
          }
          &+p{
            text-wrap: pretty;
            width: 100%;
            @media screen and (min-width: 48em) {
              width: 70%;
            }
          }
        }
        button.more, button.less{
          width: 100%;
          margin-top: 8px;
          display: flex;
          align-items: center;
          color: inherit;
          text-decoration: none;
          padding: 0 16px;
          padding-top: 2px;
          min-height: 40px;
          border-radius: 16px;
          transition: all 0.5s ease-in-out;
          border: 2px solid var(--detail);
          background: var(--detail);
          color: var(--white);
          text-align: center;
          justify-content: center;
          font-weight: bold;
          cursor:pointer;
          &:hover{
            background: transparent;
            color: var(--detail);
          }
        }
        .fastTrackItems{
          display: flex;
          flex-wrap: wrap;
          gap:8px;
          flex-direction: column;
          .fastTrackItem{
            display: flex;
            align-items: center;
            border: 2px solid var(--detail);
            background: var(--white);
            border-radius: 16px;
            padding:16px;
            gap: 16px;
            flex-direction: column;
            @media screen and (min-width: 48em) {
              flex-direction: row;
            }
            div.content{
              width: 100%;
              @media screen and (min-width: 48em) {
                padding: 0 16px;
                width: 70%;
              }
              .title{
                display: block;
                font-family: $fontDetail;
                font-size: 1.1em;
                font-weight: bold;
                margin: 0 0 10px;
              }
              .time, .description{
                display: block;
                color: #6E6E6E;
                font-size: 0.9em;
                text-wrap: pretty;
              }
              .links{
                display: flex;gap:16px;
                a{
                  display: flex;
                  align-items: center;
                  color: inherit;
                  text-decoration: none;
                  min-height: 40px;
                  border-radius: 16px;
                  transition: all 0.5s ease-in-out;
                  background: transparent;
                  color: var(--detail);
                  gap:4px;
                  .size-6{
                    width: 1.5rem;
                    height: 1.5rem;
                  }
                  span{
                    display: block;
                    font-size: 0.8em;
                    position: relative;
                    font-family:  "Inter", sans-serif;
                    margin-bottom: 0;
                    font-style: normal;
                    font-weight:bold;
                    &:before{
                      content:"";
                      width: 0;
                      height: 1px;
                      display: block;
                      position: absolute;
                      left: 0;
                      background: var(--detail);
                      bottom: 0;
                      transition: all 0.5s ease;
                    }
                  }

                  &:hover{
                      span:before{
                        width: 100%;
                      }
                    }
                }
              }
            }
            div.asset{
              width: 100%;
              background: #2694BF30;
              @media screen and (min-width: 48em) {
                width: 30%;
              }
              border-radius: 16px;
              overflow: hidden;
              a{
                width: 100%;
                  height: 100%;
                  display: flex;
              }
              img{
                width: 100%;
                height: 100%;
                display: flex;
                object-fit: cover;
              }
            }
          }
        }
      }
      .container.large{
        display: flex;
        flex-direction: column;
        @media screen and (min-width: 48em) {
          flex-direction: row;
        }
        .col-13{
          width: 100%;
          @media screen and (min-width: 48em) {
            width: 33.333%;
            padding: 0 1.5rem;
          }
        }
        .col-23{
          width: 100%;
          @media screen and (min-width: 48em) {
            width: 66.666%;
            padding: 0 1.5rem;
            padding-left: 0;
          }
        }
        .col-11{
          width: 100%;
        }
      }
      h2.title{
        font-size: 1.8em;
        line-height: 1.2em;
        width: 100%;
        @media screen and (min-width: 48em) {
          width: calc(100% - 32px);
          margin-left: 32px;
        }
        &+p{
          width: 100%;
          @media screen and (min-width: 48em) {
            width: calc(100% - 32px);
            margin-left: 32px;
          }
          color: var(--grayLight);
          font-style: italic;
          line-height: 1.4em;
          text-wrap: pretty;
        }
      }
      .title {
        a{
          color: black;
          margin: 8px 0;
          text-decoration: none;
          position: relative;
          &:before{
            content:"";
            width: 100%;
            height: 1px;
            display: block;
            position: absolute;
            left: 0;
            background: var(--detail);
            bottom: 0;
            transition: all 0.5s ease;
          }
          &:hover{
            &:before{
              width: 0;
              left: 100%;
            }
          }
        }
        &:first-letter {
          text-transform:capitalize;
        }
      }
      .projects{
        display: flex;
        flex-direction: row;
        flex-wrap:wrap;
        margin: 0 -20px;
        .project{
          padding: 15px;
          margin: 5px;
          border: 1px solid rgba($black,0.1);
          flex-grow:1;
          width: 100%;
          @media screen and (min-width: 48em) {
            max-width: calc(50% - 10px);
          }
          img{
            width: 100%;
            height: auto;
            margin-bottom: 20px;
          }
          .img-container{
            position: relative;
            .icon-wip{
              display: inline-block;
              border: none;
              padding: 1rem 2rem;
              margin: 0;
              text-decoration: none;
              background: #0069ed;
              color: #ffffff;
              font-family: sans-serif;
              font-size: 1rem;
              cursor: pointer;
              text-align: center;
              transition: background 250ms ease-in-out,
                          transform 150ms ease;
              -webkit-appearance: none;
              -moz-appearance: none;
              position: absolute;
              @media screen and (min-width: 48em) {
                right:30px;
              }
              right:10px;
              bottom: 0;
              width: 60px;
              height: 60px;
              padding: 5px;
              background: $black;
              color: white;
              border-radius: 30px;
              overflow: hidden;
              transition: width 0.75s ease;
              span{
                position: absolute;
                top: 50%;
                width: 125px;
                left: 65px;
                line-height: 20px;
                margin-top: -10px;
              }
              &:before{
                content:"";
                border-radius: 50%;
                background: white;
                transition: all 0.75s ease;
                display:block;
                width: 50px;
                height: 50px;
                background-size: 40px;
                background-repeat: no-repeat;
                background-position: center;
                @media (prefers-color-scheme: dark){
                  filter: invert(1);
                }
                background-image: url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTAwIDEwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxwYXRoIGQ9Ik04MCwzNXYtNC41YzAtMC44LTAuNy0xLjUtMS41LTEuNUg2OGwwLDBINTNsMCwwSDM4bDAsMEgyMS41Yy0wLjgsMC0xLjUsMC43LTEuNSwxLjV2MThjMCwwLjgsMC43LDEuNSwxLjUsMS41SDI2djE4aC0xLjUgICBjLTAuOCwwLTEuNSwwLjctMS41LDEuNXMwLjcsMS41LDEuNSwxLjVoMTJjMC44LDAsMS41LTAuNywxLjUtMS41UzM3LjMsNjgsMzYuNSw2OEgzNXYtOWgzMHY5aC0xLjVjLTAuOCwwLTEuNSwwLjctMS41LDEuNSAgIHMwLjcsMS41LDEuNSwxLjVoMTJjMC44LDAsMS41LTAuNywxLjUtMS41Uzc2LjMsNjgsNzUuNSw2OEg3NFY1MGg0LjVjMC44LDAsMS41LTAuNywxLjUtMS41VjM1TDgwLDM1eiBNMzguNiw0N2wxNS0xNWgxMC44bC0xNSwxNSAgIEM0OS40LDQ3LDM4LjYsNDcsMzguNiw0N3ogTTM0LjQsMzJMMjMsNDMuNFYzMkgzNC40eiBNMzUsNTZ2LTZoMzB2NkgzNXogTTY4LjYsNDdsOC40LTguNFY0N0g2OC42eiI+PC9wYXRoPjwvZz48L3N2Zz4=");
              }
              &:hover, &:focus{
                width: calc(80px + 125px);
              }
            }
          }
          &.featured{
            max-width: 100%;
            flex-grow: 2;
          }
          .tags{
            margin-bottom: 20px;
            span{
              padding: 4px 15px;
              margin-bottom: 5px;
              display: inline-block;
              font-size: 0.8em;
              background: rgba($black,0.1);
              border-radius: 10px;
              margin-right: 10px;
              cursor: default;
              &:last-child{
                margin:0;
              }
              @media (prefers-color-scheme: dark){
                background-color: $black;
                color: white;
              }
            }
          }
          p{
            color: #6E6E6E;
            @media (prefers-color-scheme: dark){
              color: #e9ebed;
            }
          }
        }
      }
      .company {
        display: flex;
        flex-direction: row;
        .company-logo{
          width: 36px;
          top:7px;
          position: relative;
          @media screen and (min-width: 48em) {
            width: 80px;
          }
          img{
            width: 100%;
            height: auto;
            border-radius: 8px;
          }
          .group-logo{
            width: 20px;
            position: absolute;
            top: 40px;
            left: -10px;
            @media screen and (min-width: 48em) {
              width: 30px;
              top: 55px;
              left: -10px;
            }
            img{
              width: 100%;
              height: auto;
              border-radius: 50%;
              border:1px solid #e9ebed;
            }
          }
        }
        .company-jobs{
          padding-top: 15px;
          padding-left: 40px;
          flex-direction: column;
          width: calc(100% - 36px);
          @media screen and (min-width: 48em) {
            width: 100%;
            padding-top: 32px;
          }
          .job{
            position: relative;
            margin-bottom: 40px;
            &:before{
              content: "";
              position: absolute;
              left: -20px;
              top: 2px;
              bottom: -100px;
              width: 2px;
              border:0;
              background: var(--actionFNT);
            }
            &:after{
              content: "";
              position: absolute;
              left: -25px;
              top: 2px;
              width: 12px;
              height: 12px;
              border: 2px solid var(--actionFNT);
              background: var(--white);
              border-radius: 50%;
            }
            &.current{
              &:after{
                background: var(--actionFNT);
              }
            }
            &.future:before,&.future:after{
              background: #dcb2b8;
              border-color: #dcb2b8;
            }
            &.current:after{
              background: var(--actionFNT);
            }
            .title{
              display: block;
              margin: 0 0 10px;
              font-size: 1.1em;
              font-weight: bold;
              .sec{
                font-weight: normal;
              }
            }
            .place, .time{
              display: block;
              color: #6E6E6E;
            }
            .pils{
              display: flex;
              flex-wrap: wrap;
              gap:4px;
              padding-top:8px;
              font-size: 0.9em;
              & > .pil{
                border: 2px solid var(--actionFNT);
                font-weight: bold;
                background-color: var(--actionFNT);
                color: var(--white);
                padding: 4px 12px;
                border-radius: 25px;
              }
            }
            p.description{
              line-height: 1.4em;
              text-wrap: pretty;
              :deep(a){
                color: black;
                margin: 8px 0;
                text-decoration: none;
                position: relative;
                &:before{
                  content:"";
                  width: 100%;
                  height: 1px;
                  display: block;
                  position: absolute;
                  left: 0;
                  background: var(--detail);
                  bottom: 0;
                  transition: all 0.5s ease;
                }
                &:hover{
                  &:before{
                    width: 0;
                    left: 100%;
                  }
                }
              }
              .links{
                margin-top:8px;
                display: flex;
                gap: 8px;
                flex-wrap: wrap;
              }
            }
            .keyEvents{
              display: flex;
              flex-direction: row;
              flex-wrap:wrap;
              margin: 16px -10px 6px;
              .keyEvent{
                background-color: rgba($black,0.1);
                padding: 20px 15px;
                margin: 0 10px 10px;
                padding-left: 90px;
                width: calc(100% - 20px);
                border-radius: 8px;
                @media screen and (min-width: 48em) {
                  width: calc(50% - 20px);
                }
                min-height: 80px;
                background-position-y: center;
                background-repeat: no-repeat;
                background-size: 50px;
                background-position-x: 20px;
                @media (prefers-color-scheme: dark){
                  background-color: white;
                  color: black;
                }
                a{
                  color: $black;
                }
                &.certification{
                  background-image: url("data:image/svg+xml;base64,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");
                }
                &.a11y{
                  background-image: url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTAwIDEwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwYXRoIGQ9Ik01MCwzLjI1QzI0LjIyLDMuMjUsMy4yNSwyNC4yMiwzLjI1LDUwYzAsMjUuNzgsMjAuOTcsNDYuNzUsNDYuNzUsNDYuNzVjMjUuNzgsMCw0Ni43NS0yMC45Nyw0Ni43NS00Ni43NSAgQzk2Ljc1LDI0LjIyLDc1Ljc4LDMuMjUsNTAsMy4yNXogTTUwLDIxLjMzYzIuODgsMCw1LjIyLDIuMzQsNS4yMiw1LjIycy0yLjM0LDUuMjItNS4yMiw1LjIycy01LjIyLTIuMzQtNS4yMi01LjIyICBTNDcuMTIsMjEuMzMsNTAsMjEuMzN6IE02OS44MSw0My4wNGwtMTUuMTUsMi4xM3Y5LjU2bDguMTcsMTkuNzJjMC42MSwxLjQ2LTAuMSwzLjE2LTEuNTYsMy43NnMtMy4xNi0wLjEtMy43Ni0xLjU2TDUwLDU4LjUzICBsLTcuNTEsMTguMTJjLTAuNjEsMS40Ni0yLjMsMi4xNi0zLjc2LDEuNTZzLTIuMTYtMi4zLTEuNTYtMy43Nmw4LjE3LTE5Ljcydi05LjU2bC0xNS4xNS0yLjEzYy0xLjI5LTAuMTgtMi4xNi0xLjYxLTEuOTQtMy4xOCAgYzAuMjItMS41NywxLjQ2LTIuNywyLjc1LTIuNTJsMTQuNjMsMi4wNmg4Ljc2bDE0LjYzLTIuMDZjMS4yOS0wLjE4LDIuNTMsMC45NSwyLjc1LDIuNTJDNzEuOTgsNDEuNDMsNzEuMSw0Mi44Niw2OS44MSw0My4wNHoiPjwvcGF0aD48L3N2Zz4=");
                }
                &.trophy{
                  background-image: url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTg2LjQ4NywxNC40NTNjLTIuOTAyLTAuNjQyLTYuMjUzLTAuMjMtOS40MDgsMC45NTljMC4wMjctMS43MDUsMC4wMTktMy4zNy0wLjAyOS00Ljk2N0g1MEgyMi45NSAgIGMtMC4wNDgsMS41OTctMC4wNTcsMy4yNjItMC4wMjksNC45NjdjLTMuMTU1LTEuMTg5LTYuNTA1LTEuNjAxLTkuNDA4LTAuOTU5Yy00LjI5MiwwLjk0NC03LjIwNiwzLjg5NC04LjIwNSw4LjI5OSAgIGMtMS4zMDUsNS43NTEsMS41NjgsMTIuMzQ1LDguMDg5LDE4LjU2OWM1LjEzOCw0LjkwMywxMi4wMzEsOC45ODIsMTkuMzExLDExLjUwMmMzLjAxNiw0LjI1Miw2Ljg3Nyw3LjY3OCwxMS43NzYsOS43NjEgICBjLTAuNzE0LDIuNjA5LTMuMjIxLDEwLjE2Ny05LjI3OSwxNC43OTJINTBoMTQuNzk2Yy02LjA1OS00LjYyNS04LjU2NS0xMi4xODMtOS4yNzktMTQuNzkyYzQuODk5LTIuMDgzLDguNzYxLTUuNTA5LDExLjc3Ni05Ljc2MiAgIGM3LjI3OS0yLjUxOSwxNC4xNzMtNi41OTgsMTkuMzExLTExLjUwMWM2LjUyMS02LjIyNSw5LjM5NC0xMi44MTgsOC4wODktMTguNTY5QzkzLjY5MywxOC4zNDcsOTAuNzc5LDE1LjM5Nyw4Ni40ODcsMTQuNDUzeiAgICBNMTcuNzM4LDM2Ljc3NGMtNC43MTYtNC41MDQtNy4wNzEtOS4yMjQtNi4yOTgtMTIuNjNjMC40NTQtMi4wMSwxLjU0NC0zLjEzOCwzLjQyOC0zLjU1NGMyLjQ4Ny0wLjU0OSw1LjczMSwwLjI4NSw4LjQwMywxLjkzOCAgIGMwLjYwNyw3LjIwOSwyLjAzMSwxNC43MzgsNC42OTYsMjEuNDE4QzI0LjEzMiw0MS45NTIsMjAuNjEsMzkuNTE2LDE3LjczOCwzNi43NzR6IE04Mi4yNjIsMzYuNzc0ICAgYy0yLjg3MiwyLjc0MS02LjM5NCw1LjE3OC0xMC4yMjksNy4xNzNjMi42NjYtNi42OCw0LjA5LTE0LjIwOSw0LjY5Ni0yMS40MThjMi42NzItMS42NTIsNS45MTYtMi40ODYsOC40MDMtMS45MzggICBjMS44ODQsMC40MTYsMi45NzQsMS41NDQsMy40MjgsMy41NTRDODkuMzMzLDI3LjU1MSw4Ni45NzgsMzIuMjcxLDgyLjI2MiwzNi43NzR6Ij48L3BhdGg+PHJlY3QgeD0iMzEiIHk9IjgxLjM0MSIgd2lkdGg9IjM4IiBoZWlnaHQ9IjguMjE0Ij48L3JlY3Q+PC9nPjwvc3ZnPg==");
                }
                &.video{
                  background-image: url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iTGF5ZXIgMSIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHg9IjBweCIgeT0iMHB4Ij48dGl0bGU+QXJ0Ym9hcmQgMTM8L3RpdGxlPjxwYXRoIGQ9Ik03MS41LDI3LjVoLTQzYTExLDExLDAsMCwwLTExLDExdjIzYTExLDExLDAsMCwwLDExLDExaDQzYTExLDExLDAsMCwwLDExLTExdi0yM0ExMSwxMSwwLDAsMCw3MS41LDI3LjVaTTYyLjczLDUwLjQ0bC0xOS41LDEwQS41LjUsMCwwLDEsNDIuNSw2MFY0MGEuNS41LDAsMCwxLC43My0uNDRsMTkuNSwxMGEuNS41LDAsMCwxLDAsLjg5WiI+PC9wYXRoPjwvc3ZnPg==");
                }
                &.training{
                  background-image: url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeD0iMHB4IiB5PSIwcHgiPjx0aXRsZT5fPC90aXRsZT48cGF0aCBkPSJNMyw1VjE5SDE0VjE3aDdWNVpNOC41LDhhMiwyLDAsMSwxLTIsMkEyLjAwMjMsMi4wMDIzLDAsMCwxLDguNSw4Wk0xMywxOEg0VjE3YTIsMiwwLDAsMSwyLTJoNWEyLDIsMCwwLDEsMiwyWiI+PC9wYXRoPjwvc3ZnPg==");
                }
              }
            }
            .products{
              margin-top: 40px;
              margin-inline: 20px;
              display: flex;
              flex-direction: column;
              gap:4px;
              .product{
                display: flex;
                flex-direction: column;
                background: var(--white);
                border:1px solid var(--lightGrey);
                border-radius: 8px;
                overflow: hidden;
                img{max-width:100%;object-fit: cover;}
                @media screen and (min-width: 48em) {
                  flex-direction: row;
                  img{max-width:30%}
                }
                & > div {
                  padding: 12px;
                  h4{

        font-family: $fontDetail;
                  }
                  p{
                    font-size:0.8em;
                    line-height: 1.3em;
                    margin-bottom:0;
                  }
                }
              }
            }
            .clients{
              display: flex;
              justify-content:space-between;
              flex-direction: column;
              @media screen and (min-width: 48em) {
                flex-direction: row;
                gap: 2%;
              }
              .client figure{
                margin: 0;
                margin-bottom: 14px;
                display: flex;
                flex-direction: row;
                width: 100%;
                gap: 10px;
                align-items: flex-end;
                @media screen and (min-width: 48em) {
                  margin: 0;
                  display: flex;
                  flex-direction: column;
                }
                a{
                  width: 50%;
                  display: block;
                  @media screen and (min-width: 48em) {
                    max-width: 100%;
                    margin: auto;
                  }
                  img{
                    width: 100%;
                    border-radius: 8px;
                  }
                }
                  figcaption{
                  font-size: 0.8rem;
                  @media screen and (min-width: 48em) {
                    text-align: center;
                    width:100%;
                  }
                  
                }
              }
            }
            .projects{
              display: flex;
              flex-direction: row;
              .project{
                img{
                  max-width: 80px;
                }
              }
            }
          }
        }
        &:last-child{
          .company-jobs .job:last-child:before{
            background: linear-gradient(0deg, rgba($actionFNT,0) 0%, rgba($actionFNT,1) 100%);
          }
        }
        &:first-child{
          margin-top: 24px;
          @media screen and (min-width: 48em) {
            margin-top: 0
          }
        }
      }
      &-instagram{

        .insta-img img {
          opacity: 0;
          transform: scale(0.8) rotate(-5deg);
          filter: blur(1.2rem);
          transition: 
            transform 0.6s ease,
            filter 0.6s ease,
            opacity 0.6s ease;
        }

        .insta-img.visible  img {
          opacity: 1;
          transform: scale(1) rotate(0deg);
          filter: blur(0);
        }

        .insta-imgs .insta-img .detail-img:first-child, .insta-imgs .insta-title .detail-img:first-child{
          h2, p{
            margin-left: 0;
            width: 100%;
          }
          @media screen and (min-width: 48em) {
            padding-left: 32px;
          }
          a{
            display: inline-flex;
            align-items: center;
            color: inherit;
            text-decoration: none;
            padding: 8px 16px;
            padding-left: 8px;
            border-radius: 4px;
            transition: background 0.5s ease-in-out;
            color: white;
            background: rgba(255,255,255,0.2);
            .icon{
              height: 2rem;
              width: 2rem;
              margin-right: 1rem;
              opacity: 0.8;
              transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
              svg{
                height: 2rem;
                width: 2rem;
                path{
                  transform: scale(.8);
                }
              }
            }
            span{
              display: block;
              font-size: 1.2em;
              position: relative;
              font-family:  "Inter", sans-serif;
              margin-bottom: 0;
              font-style: normal;
              &:after{
                content:"";
                height: 1px;
                background: currentColor;
                display: block;
                transition-delay: 0s;
                position: absolute;
                bottom: -2px;
                right: 0;
                left: 100%;
              }
            }
            &:hover{
              .icon{
                transform: translateX(8px);
              }
              background: transparent;
            }
          }
        }
        .insta-imgs{
          display: flex;
          flex-direction: row;
          flex-wrap:wrap;

          .insta-img,.insta-title{
            position: relative;
            margin-bottom: 10px;
            transition: transform 0.5s ease;
            @media screen and (min-width: 48em) {
              width: 33.333%;
                padding: 0 1.5rem;
              &:hover{
                transform: scale(1.05);
              }
            }
            &:first-child{
              @media screen and (min-width: 48em) {
                padding-top: calc(2rem + 20px);
                &:hover{
                  transform: scale(1);
                }
              }

            }
            img{
              width: 100%;
              height: auto;
              border-radius: 8px;
            }
            &:nth-child(2), &:nth-child(5), &:nth-child(8){
              padding-top: 2rem;
            }
            &:nth-child(3), &:nth-child(6), &:nth-child(9){
              padding-top: 4rem;
            }
            &-container{
              margin: 5px;
              height: 100%;
            }
            .detail-img{
              .post{
                margin: 16px 0;
                font-size: 0.9em;
                line-height: 1.4em;
                div.date, div.place{
                  color: #fafaf4;
                }
                span{
                  font-family: $fontDetail;
                  font-size: 1.5em;
                  line-height: 1.2em;
                  display: block;
                  margin-bottom: 4px;
                }
              }
            }
          }
        }
      }
    }
  }

  [hover-tooltip] {
    $caret-height: 4px;
    $caret-width: 6px;
    $distance: 10px;
    $tooltip-bg-color: rgba(39, 39, 39, 1);
    
    position: relative;
    cursor: default;
    
    &:hover {
      &::before {
        content: attr(hover-tooltip);
        font-size: 14px;
        text-align: center;
        position: absolute;
        display: block;
        left: 50%;
        min-width: 150px;
        max-width: 200px;
        bottom: calc(100% + #{$distance});
        transform: translate(-50%);
        animation: fade-in 300ms ease;
        background: $tooltip-bg-color;
        border-radius: 4px;
        padding: 10px;
        color: #ffffff;
        z-index: 200;
      }
      
      &::after {
        content: '';
        position: absolute;
        display: block;
        left: 50%;
        width: 0;
        height: 0;
        bottom: calc(100% + #{$distance - $caret-height});
        margin-left: - $caret-width/2;
        border: 1px solid black;
        border-color: $tooltip-bg-color transparent transparent transparent;
        border-width: $caret-height $caret-width 0;
        animation: fade-in 300ms ease;
        z-index: 100;
      }
    }
    
    &[tooltip-position="bottom"] {
      &:hover {
        &::before {
          bottom: auto;
          top: calc(100% + #{$distance});
        }
  
        &::after {
          bottom: auto;
          top: calc(100% + #{$distance - $caret-height});
          border-color: transparent transparent $tooltip-bg-color;
          border-width: 0 $caret-width $caret-height;
        }
      }
    }
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease-out;
  }

  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }



  @keyframes run {
    0% { left: 0;}
    100%{ left: 100%;}
  }
  @keyframes runInvert {
    0% { left: 100%;}
    100%{ left: 0%;}
  }
  @keyframes slideInFromTop {
    from {
     transform: translate(-3%, -15%);
   }
   to {
     transform: translate(0, 0);
   }
  }
  @keyframes slideInFromTopD {
    from {
     transform: translate(-3.6%, -22.5%);
   }
   to {
     transform: translate(0, 0);
   }
  }

  @keyframes heroRotateBased {
    0% { transform: rotate(-45deg);}
    100%{ transform: rotate(3605deg);}
  }

  @keyframes heroRotateBasedRev {
    0% { transform: rotate(3650deg);}
    100%{ transform: rotate(0deg);}
  }

  @keyframes spin {
    100% {
      transform: rotate(1turn);
    }
  }
</style>
